import { CONNECT_CONNECTION_TYPE } from "@circle-react/types/FlaggedContent";
import type {
  ContactSnapshot,
  FlaggedContentable,
  FlaggedContentableType,
} from "@circle-react/types/FlaggedContent";
import { formatDistance } from "date-fns";

export const getTimeAgo = (date: string, addSuffix = true) =>
  formatDistance(new Date(date), new Date(), {
    addSuffix,
  });

const isContactSnapshot = (value: unknown): value is ContactSnapshot =>
  typeof value === "object" && value !== null;

const getContactSnapshotTotal = (snapshot: ContactSnapshot): number =>
  (snapshot.post ?? 0) +
  (snapshot.comment ?? 0) +
  (snapshot.connect_connection ?? 0) +
  (snapshot.chat_room_message ?? 0);

export const shouldShowContactSnapshot = (
  contactSnapshot: ContactSnapshot | null | undefined,
  authorName: string | undefined,
): contactSnapshot is ContactSnapshot =>
  isContactSnapshot(contactSnapshot) &&
  getContactSnapshotTotal(contactSnapshot) > 0 &&
  Boolean(authorName);

export interface ContentProps {
  textBody?: string;
  tiptapBody?: object;
  trixBody?: string;
}

export const getContentProps = (
  type: FlaggedContentableType,
  contentSnapshotNote: string | undefined,
  flaggedContentable: FlaggedContentable | undefined,
): ContentProps => {
  if (type === CONNECT_CONNECTION_TYPE) {
    return { textBody: contentSnapshotNote ?? flaggedContentable?.note };
  }
  return {
    tiptapBody: flaggedContentable?.tiptap_body,
    trixBody: flaggedContentable?.body_trix_content,
  };
};
